import { BiSolidMessageAdd } from "react-icons/bi";
import "./AddNote.css";

export function AddNote({ onClick, isActive }) {
  return (
      <div className="toolbar-button-wrapper">
        <button onClick={onClick} className="add-note-button">
          <BiSolidMessageAdd />
        </button>
        {isActive && <div className="button-underline add-note-underline" />}
      </div>
  );
}
